import React from 'react';
import { Table } from 'antd';
import ReducedData from '../../../reducedData.json';
import trans from '../../../translations.json';

class LtcMapTable extends React.Component {
  state = {
    searchText: '',
    searchedColumn: '',
    data: undefined,
  };

  render() {
    //copy data coming in from props to a new object, remove some items that are too old, and build the new data for table

    var data = Object.values(ReducedData.dataLTCactive)
      .filter((item, i) => i > 0)
      .map((item, z) => {
        let inOutbreak =
          item['ï»¿Report_Data_Extracted'] ===
          ReducedData.dataLTCactive.ReportedDate;
        //console.log('item', item)
        return {
          index: z,
          ltc: item.LTC_Home,
          outbreakStatus: inOutbreak
            ? trans.LtcMap.popupInOutbreak[this.props.lang]
            : trans.LtcMap.popupNotInOutbreak[this.props.lang],
          beds: item.Beds,
          totalDeaths: item.Total_LTC_Resident_Deaths,
          total: inOutbreak && item.cases,
          residentCases: inOutbreak && item.Total_LTC_Resident_Cases,
          staffCases: inOutbreak && item.Total_LTC_HCW_Cases,
        };
      });

    const columns = [
      {
        title: trans.summary.ltc[this.props.lang],
        dataIndex: 'ltc',
        key: 'ltc',
        width: '35%',
      },
      {
        title: trans.LtcMap.outbreakStatus[this.props.lang],
        dataIndex: 'outbreakStatus',
        key: 'outbreakStatus',
        width: '25%',
      },
      {
        title: trans.LtcMap.Beds[this.props.lang],
        dataIndex: 'beds',
        key: 'beds',
        width: '5%',
      },
      {
        title: trans.overview.deaths[this.props.lang],
        dataIndex: 'totalDeaths',
        key: 'totalDeaths',
        width: '10%',
      },
      {
        title: trans.overview.total[this.props.lang],
        dataIndex: 'total',
        key: 'total',
        width: '8%',
      },
      {
        title: trans.LtcMap.Resident[this.props.lang],
        dataIndex: 'residentCases',
        key: 'residentCases',
        width: '7%',
      },
      {
        title: trans.LtcMap.Staff[this.props.lang],
        dataIndex: 'staffCases',
        key: 'staffCases',
        width: '5%',
      },
    ];

    return (
      <Table
        columns={columns}
        dataSource={data}
        scroll={{ x: 300 }}
        pagination={{ showSizeChanger: false }}
      />
    );
  }
}

export default LtcMapTable;
